/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import { IconButton, Tooltip } from '@material-ui/core';

// icons
import Edit from '@material-ui/icons/Edit';
import EditOff from '@material-ui/icons/Close';

// local imports
import { ProductService } from 'app/services';
import useDataApi from '../../../use-data-api';
import { TableUtils } from 'app/utils';
import { mapActivationStatus } from 'app/utils/mapper';
import { CustomBadge } from 'app/components/atoms';

const useProductsListService = (queries, isFilteringRef, handleUpdateStatus) => {
  const [service, setService] = useDataApi();
  const history = useHistory();

  // update status
  const updateStatusBtn = (id, status, customStatus) => {
    const tooltipTitle = status === 1 ? 'Pasifleştir' : 'Aktifleştir';
    const campaignStatus = status === 1 ? 2 : 1;

    return (
      <div className="space-x-8">
        <CustomBadge content={customStatus.text} status={customStatus.color} />
        <span className="border-r-3 "></span>
        <Tooltip arrow title={tooltipTitle} placement="top">
          <IconButton
            size="small"
            edge="start"
            onClick={() => handleUpdateStatus(id, campaignStatus)}>
            {status === 1 ? <EditOff color="error" /> : <Edit className="text-green" />}
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  // product detail cell click
  const clickToDetail = id => {
    history.push({
      pathname: `/product-management/${id}/edit-campaign`,
      state: { id }
    });
  };

  const fetchData = useCallback(async () => {
    const productsList = await ProductService.getProductsList(queries);
    const products = productsList.data.data;

    const out = products?.map(item => {
      const { id, status, ...rest } = item;

      const customStatus = mapActivationStatus(status.id);

      return {
        ...rest,
        id,
        update_status: updateStatusBtn(id, status.id, customStatus)
        // clickEvent: () => clickToDetail(id)
      };
    });

    isFilteringRef.current = false;

    return {
      table: {
        columns: TableUtils.productsList,
        rows: out
      },
      totalCount: productsList?.data?.total_count,
      total: Math.round(productsList?.data?.total_count / parseInt(queries.limit))
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [setService, fetchData]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useProductsListService;
